// Icons
import ThreeDotMenu from './icons/3 dot menu.svg';
import Add from './icons/add.svg';
import Backlog from './icons/Backlog.svg';
import Canceled from './icons/Cancelled.svg';
import Display from './icons/Display.svg';
import Done from './icons/Done.svg';
import Down from './icons/down.svg';
import HighPriority from './icons/Img - High Priority.svg';
import LowPriority from './icons/Img - Low Priority.svg';
import MediumPriority from './icons/Img - Medium Priority.svg';
import InProgress from './icons/in-progress.svg';
import NoPriority from './icons/No-priority.svg';
import UrgentPriorityColor from './icons/SVG - Urgent Priority colour.svg';
import UrgentPriorityGrey from './icons/SVG - Urgent Priority grey.svg';
import ToDo from './icons/To-do.svg';

// Status Images
import tag from './status/tag.png'

// User Images
import User1 from './users/user-1.png';
import User2 from './users/user-2.png';
import User3 from './users/user-3.png';
import User4 from './users/user-4.png';
import User5 from './users/user-5.png';
import User6 from './users/user-6.png';
import User7 from './users/user-7.png';

export const icons = { ThreeDotMenu, Add, Backlog, Canceled, Display, Done, Down, HighPriority, LowPriority, MediumPriority, InProgress, NoPriority, UrgentPriorityColor, UrgentPriorityGrey, ToDo, tag };

export const statusImages = {
    tag
};

export const userImages = {
    User1,
    User2,
    User3,
    User4,
    User5,
    User6,
    User7
};
